// This file is autogenerated by inject-version.ts. Any changes will be
// overwritten on commit!
export const VERSION = "5.0.6";
